/**
 * Neighboring-cue seek targets (ported from extension ShortcutController.seekSub).
 * Times are milliseconds; `timeMs` should already include slot delay.
 */

export type CueBoundary = {
  start: number;
  end: number;
};

export type CueSeekKind = 'prev' | 'repeat' | 'next';

export function findCueSeekTarget(
  cues: CueBoundary[],
  timeMs: number,
  kind: CueSeekKind,
): CueBoundary | undefined {
  if (!cues.length) return undefined;

  const current = cues.filter((t) => t.start <= timeMs && timeMs <= t.end);
  const currentLen = current.length;
  let target: CueBoundary | undefined;

  if (kind === 'prev') {
    const earlier = cues.filter((t) => t.start <= timeMs);
    target =
      currentLen === 0
        ? earlier[earlier.length - 1]
        : earlier[earlier.length - currentLen - 1];
  } else if (kind === 'next') {
    const later = cues.filter((t) => timeMs <= t.end);
    target = currentLen === 0 ? later[0] : later[currentLen];
  } else {
    const earlier = cues.filter((t) => t.start <= timeMs);
    if (currentLen === 0) {
      target = earlier[earlier.length - 1];
    } else {
      [target] = current;
    }
  }

  return target;
}
